import { ReactNode } from "react";

import { Button } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import { BubbleMenu, Editor } from "@tiptap/react";

import { EventProperties } from "@/types/models";
import {
  getDynamicData,
  IDynamicData,
} from "@/view/TiptapArticleBody/extensions/DataProvider";
import {
  buttonCss,
  rootCss,
  triangleCss,
  wrapperCSS,
} from "./BaseTextSelectionMenu.style";
import { shouldShow } from "./utils";

interface BaseTextSelectionMenuProps {
  editor: Editor;
  title: string;
  onClick: () => void;
  icon: ReactNode;
  eventProperties?: EventProperties;
  dataTestId?: string;
}

export const BaseTextSelectionMenu = ({
  editor,
  title,
  onClick,
  icon,
  eventProperties,
  dataTestId = "BaseTextSelectionMenu",
}: BaseTextSelectionMenuProps) => {
  const state = editor.state;
  const { selection } = state;
  const { from, to } = selection;
  const { levelId } = getDynamicData(state) as IDynamicData;

  const defaultEventProperties = {
    objectType: "Annotation",
    actionName: "Create",
    streamProperties: {
      content_type: "Article",
      content_id: levelId,
      selected_word_count: `${to - from}`,
    },
  };

  const ButtonWithTrackEvent = withTrackEvent(
    Button,
  ) as React.ForwardRefExoticComponent<
    React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
  >;

  return (
    <span data-testid={dataTestId}>
      <BubbleMenu
        tippyOptions={{ duration: 100 }}
        editor={editor}
        shouldShow={shouldShow}
        css={wrapperCSS}
      >
        <div style={{ display: "flex" }}>
          {/* @ts-ignore: AnnotateIcon is not typed */}
          <ButtonWithTrackEvent
            __cssFor={{ root: buttonCss(true) }}
            onClick={onClick}
            {...(eventProperties || defaultEventProperties)}
            flavor={Button.flavors.incognito}
            size={Button.sizes.lg}
          >
            <div css={rootCss(true)}>
              {icon}
              {title}
            </div>
          </ButtonWithTrackEvent>
        </div>
        <div css={triangleCss} />
      </BubbleMenu>
    </span>
  );
};
